import { create } from "zustand";

const formStore = (set) => ({
  forms: [],
  setForms: (newData) => set({ forms: newData }),

  toSave: null,
  setToSave: (newData) => set({ toSave: newData }),
});

export const useFormStore = create(formStore);